<div class="">
  <!-- Sidebar -->
  <app-sidebar
    class="md:fixed top-4 bottom-4 left-4 lg:w-[280px] rounded-[33px]"
  />

  <!-- Main Content -->
  <div class="max-md:pl-[10px] lg:pl-[320px] pr-2 lg:pr-9">
    <!-- Header -->
    <div class="pt-4">
      <app-header />
    </div>

    <!-- Scrollable Content Area -->
    <main>
      <div class="pr-1">
        <router-outlet />
        <!-- Mobile Side Content (shown at bottom) -->
        <div class="mt-8 app-side-content-column-container">
          <app-side-content-column></app-side-content-column>
        </div>
      </div>
    </main>
  </div>
</div>
